module.exports = __webpack_public_path__ + "static/media/aladdin_snes_gameover.f1ea788d.gif";